

class V0ApiService {
  constructor() {
    this.baseURL = `${process.env.REACT_APP_API_BASE_URL}/${process.env.REACT_APP_API_PATH}/v0`;
  }
}

export default V0ApiService;
